import { HttpStatus as T } from "@hprofits/utils";
import { AuthRejectedDataSchema as a, ExpectationFailedDataSchema as t, FieldCannotBeUpdatedDataSchema as _, InUseDataSchema as N, AlreadyExistsDataSchema as I, EntityNotFoundDataSchema as D, ValidationErrorDataSchema as A } from "./schemas.js";
var S = /* @__PURE__ */ ((E) => (E.REQUEST_BODY_VALIDATION = "REQUEST_BODY_VALIDATION", E.ENTITY_NOT_FOUND = "ENTITY_NOT_FOUND", E.ENTITY_ALREADY_EXISTS = "ENTITY_ALREADY_EXISTS", E.ENTITY_IN_USE = "ENTITY_IN_USE", E.FIELD_CANNOT_BE_UPDATED = "FIELD_CANNOT_BE_UPDATED", E.EXPECTATION_FAILED = "EXPECTATION_FAILED", E.AUTH_REJECTED = "AUTH_REJECTED", E))(S || {});
const s = {
  REQUEST_BODY_VALIDATION: { status: T.BAD_REQUEST, data: A },
  ENTITY_NOT_FOUND: { status: T.UNPROCESSABLE_ENTITY, data: D },
  ENTITY_ALREADY_EXISTS: { status: T.CONFLICT, data: I },
  ENTITY_IN_USE: { status: T.CONFLICT, data: N },
  FIELD_CANNOT_BE_UPDATED: { status: T.CONFLICT, data: _ },
  EXPECTATION_FAILED: { status: T.UNPROCESSABLE_ENTITY, data: t },
  AUTH_REJECTED: { status: T.UNPROCESSABLE_ENTITY, data: a }
};
export {
  S as ApiErrorCode,
  s as errorMapping
};
//# sourceMappingURL=constants.js.map
